export default "/_next/static/images/facebook-icon.svg";